"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateHtml = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var generateHtml = exports.generateHtml = function generateHtml(string, word) {
  var regex = new RegExp("(".concat(word, ")"), 'gi');
  return string.replace(regex, "<span class=\"".concat(_style["default"].highlighted, "\">$1</span>"));
};
var _default = exports["default"] = function _default(_ref) {
  var string = _ref.string,
    word = _ref.word;
  if (!word || typeof string !== 'string' || !string.toUpperCase().includes(word.toUpperCase())) {
    return string;
  }
  var html = generateHtml(string, word);
  return /*#__PURE__*/_react["default"].createElement("span", {
    dangerouslySetInnerHTML: {
      __html: html
    }
  });
};